import { Controller } from '@hotwired/stimulus'

const DELAY = 0 // Tweak this to increase the status change delay. 0 means no delay at all.

/**
 * This controller is solely responsible for updating the Proof Point status
 * for vanity purposes. The status is 'checking' by default and gets updated
 * to either 'evidenced' or 'verified' after a random number of seconds.
 */
export default class extends Controller {
  static values = {
    status: String
  }

  connect () {
    if (this.statusValue !== 'evidenced' && this.statusValue !== 'verified') return

    setTimeout(() => {
      this.element.querySelector('[checking]').dataset.state = 'checked'
      this.element.querySelector(`[${this.statusValue}]`).hidden = false
    }, DELAY)
  }
}
